import API_BASE_URL from '../Config';

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getCiudades = async () => {
    const response = await fetch(`${API_BASE_URL}/ciudades`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al listar ciudades');
    return response.json();
};

export const getCiudadesPorDepartamento = async (deptoId) => {
    const response = await fetch(`${API_BASE_URL}/ciudades/por-departamento/${deptoId}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al listar ciudades');
    return response.json();
};

export const getCiudadesPaginadas = async (page = 0, size = 10, search = '') => {
    const response = await fetch(`${API_BASE_URL}/ciudades/page?page=${page}&size=${size}&search=${search}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Error al cargar ciudades paginadas');
    return response.json();
};

export const getCiudadById = async (id) => {
    const response = await fetch(`${API_BASE_URL}/ciudades/${id}`, {
        headers: getAuthHeaders()
    });
    if (!response.ok) throw new Error('Ciudad no encontrada');
    return response.json();
};

export const createCiudad = async (data) => {
    const response = await fetch(`${API_BASE_URL}/ciudades`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        let errorMsg = 'Error al crear ciudad';
        try {
            const errorData = await response.json();
            errorMsg = errorData.message || (errorData.cause ? `Error: ${errorData.cause}` : errorMsg);
        } catch (e) {}
        throw new Error(errorMsg);
    }
    return response.json();
};

export const updateCiudad = async (id, data) => {
    const response = await fetch(`${API_BASE_URL}/ciudades/${id}`, {
        method: 'PUT',
        headers: getAuthHeaders(),
        body: JSON.stringify(data)
    });
    if (!response.ok) {
        let errorMsg = 'Error al actualizar ciudad';
        try {
            const errorData = await response.json();
            errorMsg = errorData.message || (errorData.cause ? `Error: ${errorData.cause}` : errorMsg);
        } catch (e) {}
        throw new Error(errorMsg);
    }
    return response.json();
};

export const deleteCiudad = async (id) => {
    const response = await fetch(`${API_BASE_URL}/ciudades/${id}`, {
        method: 'DELETE',
        headers: getAuthHeaders()
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.message || 'Error al eliminar ciudad');
    }
};
